<div class="auth-page">
  <div class="auth-card auth-card--with-back">
    <a class="auth-back-button" [routerLink]="backLink">
      <i class="bi bi-arrow-left"></i>
      Back
    </a>
    <div class="auth-card-inner">
      <div class="auth-visual">
        <p class="auth-visual-kicker">Appstrax</p>
        @if (authStep != null && !isEditMode) {
          <ol class="auth-step-indicator" aria-label="Setup progress">
            @for (s of setupSteps; track s) {
              <li [class.is-active]="authStep >= s"></li>
            }
          </ol>
        }
        <h1 class="auth-visual-title">
          {{ isEditMode ? 'Edit Organization' : 'Create Organization' }}
        </h1>
        <p class="auth-visual-subtitle">
          {{ isEditMode ? 'make your changes' : 'to get started' }}
        </p>
        @if (logoPreviewUrl) {
          <div class="logo-preview">
            <img [src]="logoPreviewUrl" alt="Logo preview" />
          </div>
        }
        <div class="auth-visual-deco" aria-hidden="true"></div>
      </div>

      <div class="auth-form">
        <div class="auth-form-header-row">
          <div class="welcome-block">
            <h2 class="auth-form-title">Welcome!</h2>
            <p class="auth-form-lead">Register your Organization</p>
          </div>
        </div>

        <form (ngSubmit)="createOrganization()" #form="ngForm" autocomplete="off">
          <div class="form-group">
            <label for="name" class="visually-hidden">Organization Name</label>
            <div class="input-with-icon">
              <i class="bi bi-building"></i>
              <input
                type="text"
                class="form-control"
                id="name"
                name="name"
                [(ngModel)]="organization.name"
                placeholder="* Organization Name"
                required
              />
            </div>
          </div>

          <div class="form-group">
            <label for="description" class="visually-hidden">Organization Description</label>
            <div class="input-with-icon">
              <i class="bi bi-file-earmark-text"></i>
              <input
                type="text"
                class="form-control"
                id="description"
                name="description"
                [(ngModel)]="organization.description"
                placeholder="* Organization Description"
                required
              />
            </div>
          </div>

          <div class="form-group">
            <label for="address" class="visually-hidden">Address</label>
            <div class="input-with-icon">
              <i class="bi bi-house"></i>
              <input
                type="text"
                class="form-control"
                id="address"
                name="address"
                [(ngModel)]="organization.address"
                placeholder="* Address"
                required
              />
            </div>
          </div>

          <div class="form-row">
            <div class="form-col">
              <div class="form-group">
                <label for="country" class="visually-hidden">Country</label>
                <div class="input-with-icon">
                  <i class="bi bi-globe"></i>
                  <input
                    type="text"
                    class="form-control"
                    id="country"
                    name="country"
                    [(ngModel)]="organization.country"
                    placeholder="* Country"
                    required
                  />
                </div>
              </div>
            </div>
            <div class="form-col">
              <div class="form-group">
                <label for="email" class="visually-hidden">Email</label>
                <div class="input-with-icon">
                  <i class="bi bi-envelope"></i>
                  <input
                    type="text"
                    class="form-control"
                    id="email"
                    name="email"
                    [(ngModel)]="organization.email"
                    placeholder="* Email"
                    required
                  />
                </div>
              </div>
            </div>
          </div>

          <div class="form-row">
            <div class="form-col">
              <div class="form-group">
                <label for="city" class="visually-hidden">City</label>
                <div class="input-with-icon">
                  <i class="bi bi-building"></i>
                  <input
                    type="text"
                    class="form-control"
                    id="city"
                    name="city"
                    [(ngModel)]="organization.city"
                    placeholder="* City"
                    required
                  />
                </div>
              </div>
            </div>
            <div class="form-col">
              <div class="form-group">
                <label for="state" class="visually-hidden">State</label>
                <div class="input-with-icon">
                  <i class="bi bi-globe"></i>
                  <input
                    type="text"
                    class="form-control"
                    id="state"
                    name="state"
                    [(ngModel)]="organization.state"
                    placeholder="* State/Province"
                    required
                  />
                </div>
              </div>
            </div>
          </div>

          <div class="form-row">
            <div class="form-col">
              <div class="form-group">
                <label for="zip" class="visually-hidden">Zip</label>
                <div class="input-with-icon">
                  <i class="bi bi-house"></i>
                  <input
                    type="text"
                    class="form-control"
                    id="zip"
                    name="zip"
                    [(ngModel)]="organization.zip"
                    placeholder="* Zip"
                    required
                  />
                </div>
              </div>
            </div>
            <div class="form-col">
              <div class="form-group">
                <label for="phone" class="visually-hidden">Phone</label>
                <div class="input-with-icon">
                  <i class="bi bi-phone"></i>
                  <input
                    type="text"
                    class="form-control"
                    id="phone"
                    name="phone"
                    [(ngModel)]="organization.phone"
                    placeholder="* Phone"
                    required
                  />
                </div>
              </div>
            </div>
          </div>

          <div class="form-group">
            <label for="website" class="visually-hidden">Website</label>
            <div class="input-with-icon">
              <i class="bi bi-globe"></i>
              <input
                type="text"
                class="form-control"
                id="website"
                name="website"
                [(ngModel)]="organization.website"
                placeholder="Website"
              />
            </div>
          </div>

          <button type="button" class="btn btn-outline-secondary mb-4" (click)="logoFileInput.click()">
            <i class="bi bi-image me-2"></i>
            Choose Logo
          </button>
          <input
            #logoFileInput
            type="file"
            id="logoFile"
            name="logoFile"
            accept="image/*"
            class="d-none"
            (change)="onLogoSelected($event)"
          />

          @if (errorMessage) {
            <div class="alert alert-danger mb-3">
              {{ errorMessage }}
            </div>
          }

          <button
            type="submit"
            class="btn btn-primary auth-submit"
            [disabled]="!isFormValid()"
            [ngClass]="{ disabled: isLoading }"
          >
            @if (isLoading) {
              <span class="spinner-border spinner-border-sm" aria-hidden="true"></span>
            }
            <span class="ms-2" role="status">{{
              isEditMode ? 'Update Organization' : 'Create Organization'
            }}</span>
          </button>
        </form>
      </div>
    </div>
  </div>
</div>
